import { InputAdornment, Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, ToggleButtonGroupField, Select } from '@occc-app/design-system';
import { OfferFilter } from '@occc/graphql';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { OfferSelect } from '@occc-app/routes/CampaignComponents/components/OfferSelect/OfferSelect';

import { useField } from 'react-final-form';
import { fulfillmentItems, operatorsOptions } from './constants';
import { FulfillmentFormValues, OfferFulfillment } from '../../types';

type FulfillmentFormArrayItemProps = {
  fieldArrayName: string;
  makeOffersFilter: (search: string) => OfferFilter;
};

export const FulfillmentFormArrayItem = ({
  fieldArrayName,
  makeOffersFilter,
}: FulfillmentFormArrayItemProps) => {
  const {
    input: { value: fulfillment },
  } = useField<FulfillmentFormValues>(fieldArrayName, { subscription: { value: true } });

  const isOfferFulfilled = fulfillment?.fulfilled === OfferFulfillment.Fulfilled;
  const operator = fulfillment?.operator;
  const timesFulfilled = fulfillment?.timesFulfilled;

  return (
    <>
      <Grid container spacing={3} mb={2}>
        <Grid xs={12} sm={6} md={3} display='flex' justifyContent='center'>
          <ToggleButtonGroupField name={`${fieldArrayName}.fulfilled`} buttons={fulfillmentItems} />
        </Grid>
        <Grid xs={12} sm={6} md={3}>
          <OfferSelect
            makeOffersFilter={makeOffersFilter}
            name={`${fieldArrayName}.targetOffer`}
            label='Campaign Component'
          />
        </Grid>
        {isOfferFulfilled && (
          <>
            <Grid xs={12} sm={6} md={3}>
              <Select
                name={`${fieldArrayName}.operator`}
                label='Choose a response'
                data={operatorsOptions}
                formControlProps={{ size: 'medium', margin: 'none' }}
              />
            </Grid>
            {operator && (
              <Grid xs={12} sm={6} md={3}>
                <TextField
                  name={`${fieldArrayName}.timesFulfilled`}
                  label='Times'
                  fieldProps={{
                    parse: parseNumber,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>{`time${
                        timesFulfilled && timesFulfilled > 1 ? 's' : ''
                      }`}</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}
          </>
        )}
      </Grid>
    </>
  );
};
